<template>
  <TemplatePricing v-bind="data" />
</template>

<script setup>
// Layout
definePageMeta({
  layout: 'default',
})

// i18n
defineI18nRoute({
  paths: {
    de: '/preise',
    en: '/pricing',
    es: '/precios',
    fr: '/tarifs',
  },
})

// Composables
const { page } = useAnalyticsJS()
const { setAvailableLanguages } = useAvailableLanguages()
const { updateListItems } = useBreadcrumb()
const { state } = useConditionalPreviewMode()
const { locale } = useI18n()
const localePath = useLocalePath()
const getRouteBaseName = useRouteBaseName()
const { public: publicRuntimeConfig } = useRuntimeConfig()

// Async Data
const { data } = await useFetch(`/api/content/pages/pricing/${locale.value}`, {
  key: `page-test-${locale.value}`,
  query: {
    preview: state.preview,
  },
})

// Meta
const head = useLocaleHead({
  identifierAttribute: 'id',
  addSeoAttributes: true,
})

useSeoMeta({
  title: data.value.page.titleSEO,
  description: data.value.page.descriptionSEO,
  ogTitle: data.value.page.titleSEO,
  ogDescription: data.value.page.descriptionSEO,
  twitterTitle: data.value.page.titleSEO,
  twitterDescription: data.value.page.descriptionSEO,
})

useHead({
  link: head.value.link,
  meta: head.value.meta,
  script: [
    {
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        'itemListElement': [
          {
            '@type': 'ListItem',
            'position': 1,
            'name': data.value.home.trackingBreadcrumbTitle,
            'item': `${publicRuntimeConfig.baseUrl}${localePath('index')}`,
          },
          {
            '@type': 'ListItem',
            'position': 2,
            'name': data.value.page.trackingBreadcrumbTitle,
          },
        ],
      }),
      type: 'application/ld+json',
    },
  ],
})

// Lifecycle Hooks
onMounted(() => {
  page(data.value.page.trackName || 'Pricing')
  setAvailableLanguages()
  updateListItems([
    {
      item: localePath('index'),
      name: data.value.home.trackingBreadcrumbTitle,
    },
    {
      item: localePath({ name: getRouteBaseName() }),
      name: data.value.page.trackingBreadcrumbTitle,
    },
  ])
})
</script>
